import React, {useState} from 'react';
import useDidMountEffect from "../../utils/useDidMountEffect";
import apiUser from "../../apiUser";
import {omit} from "lodash";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Adjust from "./Adjust/Adjust";
import AdjustCard from "./Adjust/AdjustCard";
import {Col, Row} from "reactstrap";
import {Route, Switch} from "react-router-dom";
import appUserRoutes from "../../appUserRoutes";
import TimesCard from "./Times/TimesCard";
import Times from "./Times/Times";
import Manuals from "./Manuals/Manuals";
import ManualsCard from "./Manuals/ManualsCard";
import ComfortWiring from "./ComfortWiring/ComfortWiring";
import ComfortWiringCard from "./ComfortWiring/ComfortWiringCard";
import RelaysFuses from "./RelaysFuses/RelaysFuses";
import RelaysFusesCard from "./RelaysFuses/RelaysFusesCard";
import WiringCard from "./Wiring/WiringCard";
import Wiring from "./Wiring/Wiring";
import Diagnostics from "./Diagnostics/Diagnostics";
import DiagnosticsCard from "./Diagnostics/DiagnosticsCard";
import ManualsErrorCode from "./Manuals/ManualsErrorCode";
import {useTecRmi} from "../../contexts/TecRmiContext";
import DiagnosticsErrorCode from "./Diagnostics/DiagnosticsErrorCode";
import SosCard from "./Sos/SosCard";
import Sos from "./Sos/Sos";
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {TAB_MODULES} from "../../views/UserViews/TecRmi/MainView";
import ParamsWrapper from "./ParamsWrapper";
import BodyGraphicsCard from "./BodyGraphics/BodyGraphicsCard";
import BodyGraphics from "./BodyGraphics/BodyGraphics";
import i18n from "i18n/init"

import bodyGraphicsIcon from "assets/img/icons/tec-rmi/icon-body-graphics.svg";
import timesIcon from "assets/img/icons/tec-rmi/icon-times.svg";
import iconAdjust from "assets/img/icons/tec-rmi/icon-adjust.svg";
import iconManuals from "assets/img/icons/tec-rmi/icon-manuals.svg";
import iconDiagnostics from "assets/img/icons/tec-rmi/icon-diagnostic.svg";
import iconWiring from "assets/img/icons/tec-rmi/icon-wiring.svg";
import iconSos from "assets/img/icons/tec-rmi/icon-sos.svg";
import iconRelaysFuses from "assets/img/icons/tec-rmi/icon-relays-fuses.svg";
import iconComfortWiring from "assets/img/icons/tec-rmi/icon-comfort-wiring.svg";

/**
     * AD - Dane techniczne
     * LT - Czasochłonność
     * TM - Instrukcje naprawcze
     * CWD - Schematy elektryczne systemów komfortu
     * DI - Dane diagnostyczne
     * FR - Rozmieszczenie bezpieczników i przekaźników
     * SOS - Podręczniki SOS
     * WD - Schematy połączeń
     * TD - Opony
 * MD - Prace przeglądowe
 * COO - cost of ownership
 * BG - body graphics
 * MP - mount position
 * PAINT - malowanie - deprecated
 */

/**
 * 1 - LT - Czasochłonność
 * 2 - AD - Dane techniczne
 * 3 - TM - Instrukcje naprawcze
 * 4 -
 * 5 - DI - Dane diagnostyczne
 * 6 -
 * 7 - WD - Schematy połączeń
 * 8 - SOS - Podręczniki SOS
 * 9 - FR - Rozmieszczenie bezpieczników i przekaźników
 * 10 -
 * 11 - CWD - Schematy elektryczne systemów komfortu
 */

export const getByModuleId = (moduleId, type = null) => {
  const obj = () => {
    switch (moduleId) {
      case 'bg': {
        return  {
          component: BodyGraphics,
          icon: bodyGraphicsIcon,
          name: i18n.t('tec_rmi:module.body_graphics'),
          uriName: 'wyszukiwanie-graficzne',
        }
      }
      case 1: {
        return  {
          component: Times,
          icon: timesIcon,
          name: i18n.t('tec_rmi:module.times'),
          uriName: 'czasochlonnosc',
        }
      }
      case 2: {
        return {
          component: Adjust,
          icon: iconAdjust,
          name: i18n.t('tec_rmi:module.adjust'),
          uriName: 'dane-techniczne',
        }
      }
      case 3: {
        return {
          component: Manuals,
          icon: iconManuals,
          name: i18n.t('tec_rmi:module.manuals'),
          uriName: 'instrukcje-naprawcze',
        }
      }
      case '3.error': {
        return {
          component: ManualsErrorCode,
          name: i18n.t('module.manuals_error_code'),
          uriName: 'instrukcje-naprawcze-kody-bledow',
        }
      }
      case 5: {
        return {
          component: Diagnostics,
          icon: iconDiagnostics,
          name: i18n.t('tec_rmi:module.diagnostics'),
          uriName: 'dane-diagnostyczne',
        }
      }
      case '5.error': {
        return {
          component: DiagnosticsErrorCode,
          name: i18n.t('module.diagnostics_error_code'),
          uriName: 'dane-diagnostyczne-kody-bledow',
        }
      }
      case 7: {
        return {
          component: Wiring,
          icon: iconWiring,
          name: i18n.t('tec_rmi:module.wiring'),
          uriName: 'schematy-polaczen',
        }
      }
      case 8: {
        return {
          component: Sos,
          icon: iconSos,
          name: i18n.t('tec_rmi:module.sos'),
          uriName: 'podreczniki-sos',
        }
      }
      case 9: {
        return {
          component: RelaysFuses,
          icon: iconRelaysFuses,
          name: i18n.t('tec_rmi:module.relays_fuses'),
          uriName: 'rozmieszczenie-bezpiecznikow-i-przekaznikow',
        }
      }
      case 11: {
        return {
          component: ComfortWiring,
          icon: iconComfortWiring,
          name: i18n.t('tec_rmi:module.comfort_wiring'),
          uriName: 'schematy-elektryczne-systemow-komfortu',
        }
      }
      default: return null
    }
  }

  const o = obj();

  if(!o){
    return null
  }

  if(!type){
    return  o
  }

  return o[type]
}

export const MODULE_BODY_GRAPHICS = 'bg'
export const MODULE_TIMES = 1
export const MODULE_ADJUST = 2
export const MODULE_MANUALS = 3
export const MODULE_MANUALS_ERROR_CODE = '3.error'
export const MODULE_DIAGNOSTICS = 5
export const MODULE_DIAGNOSTICS_ERROR_CODE = '5.error'
export const MODULE_WIRING = 7
export const MODULE_COMFORT_WIRING = 11
export const MODULE_RELAYS_FUSES = 9
export const MODULE_SOS = 8

const Modules = props => {
  const { showType, getApiPrimaryParams, ident } = useTecRmi()
  const [availableModules, setAvailableModules] = useState(null)

  useDidMountEffect(() => {
    apiUser.tecRmi.vehicleTree.availableModules(getApiPrimaryParams())
      .then(res => setAvailableModules(omit(res.data[0], ['TypeId'])))
  })

  const routes = [
    MODULE_BODY_GRAPHICS,
    MODULE_TIMES,
    MODULE_ADJUST,
    MODULE_MANUALS_ERROR_CODE,
    MODULE_MANUALS,
    MODULE_DIAGNOSTICS_ERROR_CODE,
    MODULE_DIAGNOSTICS,
    MODULE_WIRING,
    MODULE_COMFORT_WIRING,
    MODULE_RELAYS_FUSES,
    MODULE_SOS,
  ].map(moduleId => ([
    {path: appUserRoutes.tecRmi.tabModule(':ident', getByModuleId(moduleId, 'uriName')) + '*', render: _p => <React.Fragment>
        <BreadcrumbsItem to={appUserRoutes.tecRmi.tabModule(':ident', getByModuleId(moduleId, 'uriName'))}>{getByModuleId(moduleId, 'name')}</BreadcrumbsItem>
        <ParamsWrapper {..._p} component={getByModuleId(moduleId, 'component')} />
      </React.Fragment>},
  ])).flatMap(arr => arr)

  return (
    <div className="modules-list h-100">
      <BreadcrumbsItem to={appUserRoutes.tecRmi.tab(ident, TAB_MODULES)}>Moduły</BreadcrumbsItem>
      <Switch>
        {routes.map((route, key) => <Route
          key={key.toString()}
          path={route.path}
          render={route.render}
        />)}

        <Route component={() => {
          if(!availableModules){
            return <LoadingSpinner />
          }

          return <Row>
            {availableModules.BgAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><BodyGraphicsCard /></Col>}
            {availableModules.AdAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><AdjustCard /></Col>}
            {availableModules.LtAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><TimesCard /></Col>}
            {availableModules.TmAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><ManualsCard /></Col>}
            {availableModules.DiAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><DiagnosticsCard /></Col>}
            {availableModules.WdAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><WiringCard /></Col>}
            {availableModules.CWDAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><ComfortWiringCard /></Col>}
            {availableModules.SosAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><SosCard /></Col>}
            {availableModules.FrAvailable && <Col className="mb-4" sm={6} md={4} lg={3}><RelaysFusesCard /></Col>}
          </Row>
        }} />
      </Switch>
    </div>
  );
};

export default Modules;